import { useQuery } from '@tanstack/react-query'

import { useApi } from '@fortem-monorepo/react-spa'
import { Funds } from '@fortem-monorepo/web-sdk'

import { queryKeys } from './keys'

export const useFunds = (showAll = false) => {
  const api = useApi()

  const query = useQuery({
    queryKey: queryKeys.funds,
    queryFn: () => api.funds.getAll(),
  })

  return {
    query,
    data: (query.data ?? []).filter((fund) => {
      const hasFundId = !!fund.fund_id
      const show = showAll ? true : fund.active
      return hasFundId && show
    }),
  }
}

export const useNav = (params: Funds.GetNavParams) => {
  const api = useApi()

  return useQuery({
    queryKey: queryKeys.nav(params),
    queryFn: () => api.funds.nav.getNav(params),
  })
}

export const useFundHolidays = (params: Funds.GetFundHolidaysParams, enabled: boolean) => {
  const api = useApi()
  const filters = { ...params, fund_ids: [...new Set(params.fund_ids)].sort((a, b) => a - b) }
  return useQuery({
    queryKey: queryKeys.holidays(filters),
    queryFn: () => api.funds.getHolidays(filters),
    enabled,
  })
}
